import { render, staticRenderFns } from "./crudPricesListsProducts.vue?vue&type=template&id=01b6c19c&"
import script from "./crudPricesListsProducts.vue?vue&type=script&lang=js&"
export * from "./crudPricesListsProducts.vue?vue&type=script&lang=js&"
import style0 from "./crudPricesListsProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports